// Stripe-style animated aurora gradient background (soft, on white).
export const AuroraBackground = ({ className = "", opacity = 0.55 }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden style={{ opacity }}>
    <div
      className="aurora-blob animate-float-slow"
      style={{ width: 540, height: 540, top: -180, left: -120, background: "radial-gradient(circle at 30% 30%, #F5C542, transparent 68%)" }}
    />
    <div
      className="aurora-blob animate-float-slow-2"
      style={{ width: 620, height: 620, top: -220, right: -160, background: "radial-gradient(circle at 60% 40%, #C77DFF, transparent 70%)" }}
    />
    <div
      className="aurora-blob animate-float-slow"
      style={{ width: 500, height: 500, bottom: -240, left: "32%", background: "radial-gradient(circle at 50% 50%, #7CB9F2, transparent 70%)" }}
    />
    <div
      className="aurora-blob animate-float-slow-2"
      style={{ width: 420, height: 420, bottom: -180, right: "12%", background: "radial-gradient(circle at 50% 50%, #F5876B, transparent 70%)" }}
    />
  </div>
);

// Animated gradient frame that wraps product imagery / UI mockups (Stripe style).
export const GradientFrame = ({ children, className = "", pad = "p-2.5" }) => (
  <div className={`relative rounded-[2rem] ${pad} brand-gradient shadow-[0_30px_80px_-20px_rgba(168,85,247,0.35)] ${className}`}>
    <div className="relative rounded-[1.5rem] overflow-hidden bg-white">{children}</div>
  </div>
);
